import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["usageTracker"];
import getComponentName from 'react-utils/getComponentName';
import { getUsageTracker } from 'editor-components/utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const USAGE_EVENT_KEY = 'componentInteraction';
export function withUsageTracking(WrappedComponent) {
  const ComponentWithUsageTracking = _ref => {
    let {
        usageTracker: __usageTracker
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    function handleTrackUsage(action, extraProps = {}) {
      const usageTracker = getUsageTracker(__usageTracker);
      const properties = Object.assign({
        action
      }, extraProps);
      usageTracker.track(USAGE_EVENT_KEY, properties);
    }
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
      onTrackUsage: handleTrackUsage
    }, rest));
  };
  ComponentWithUsageTracking.displayName = `withUsageTracking(${getComponentName(WrappedComponent)})`;
  ComponentWithUsageTracking.WrappedComponent = WrappedComponent;
  return ComponentWithUsageTracking;
}
export default withUsageTracking;